import { apiFetch, getToken } from './client';

const BASE_URL = process.env.REACT_APP_API_URL || '/api';

export const getRequirements = (systemId) =>
  apiFetch(`/odp/requirements?system_id=${systemId}`);

export const updateRequirement = (id, systemId, payload) =>
  apiFetch(`/odp/requirements/${id}?system_id=${systemId}`, {
    method: 'PATCH',
    body:   JSON.stringify(payload),
  });

export const getCurrentSsp  = (systemId) => apiFetch(`/odp/ssp/current?system_id=${systemId}`);
export const getSspHistory  = (systemId) => apiFetch(`/odp/ssp/history?system_id=${systemId}`);

export const deleteSsp = (uuid, systemId) =>
  apiFetch(`/odp/ssp/${uuid}?system_id=${systemId}`, { method: 'DELETE' });

export const parseSsp = (uuid, systemId) =>
  apiFetch(`/odp/ssp/${uuid}/parse?system_id=${systemId}`, { method: 'POST' });

export const applySsp = (uuid, systemId, requirementIds) =>
  apiFetch(`/odp/ssp/${uuid}/apply?system_id=${systemId}`, {
    method: 'POST',
    body:   JSON.stringify({ requirement_ids: requirementIds }),
  });

export const exportSsp = (systemId, format, signedBy) =>
  apiFetch(`/odp/ssp/export?system_id=${systemId}`, {
    method: 'POST',
    body:   JSON.stringify({ format, signed_by: signedBy }),
  });

export const getApplicableStigs = (reqId, systemId) =>
  apiFetch(`/odp/requirements/${reqId}/applicable-stigs?system_id=${systemId}`);

export const sspDownloadUrl = (uuid, systemId) =>
  `${BASE_URL}/odp/ssp/${uuid}/download?system_id=${systemId}`;

// Multipart uploads can't go through apiFetch (it sets Content-Type to JSON)
export async function uploadSsp(systemId, file) {
  const fd = new FormData();
  fd.append('file', file);
  const res = await fetch(`${BASE_URL}/odp/ssp/upload?system_id=${systemId}`, {
    method:  'POST',
    headers: { Authorization: `Bearer ${getToken()}` },
    body:    fd,
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || `Upload failed (${res.status})`);
  }
  return res.json();
}
